import request from '@/utils/request'

// 查询消息列表
export function listMessage(url,query) {
  return request({
    url:  url + '/actuator/message/list',
    method: 'get',
    params: query
  })
}

// 查询作品消息列表
export function workMsgList (url, query) {
  return request({
    url: url + '/actuator/message/workMsgList',
    method: 'get',
    params: query
  })
}

// 查询消息详细
export function getMessage (id) {
  return request({
    url: '/system/message/' + id,
    method: 'get'
  })
}

// 新增消息
export function addMessage (data) {
  return request({
    url: '/system/message',
    method: 'post',
    data: data
  })
}

// 修改消息
export function updateMessage (url, data) {
  return request({
    url: url + '/actuator/message',
    method: 'put',
    data: data
  })
}

// 删除消息
export function delMessage (id) {
  return request({
    url: '/system/message/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/system/message.js